export const THEME_KEYS = ['blue', 'purple', 'green', 'orange', 'pink'] as const;
export type ThemeKey = (typeof THEME_KEYS)[number];

// 'auto' = OS prefers-color-scheme 추종(§17.2). 단 data-mode 에는 절대 기록되지 않고
// applyToDocument 가 항상 light|dark 로 resolve 한다(§16-C7, tokens.css 에 auto 셀렉터 없음).
export const THEME_MODES = ['light', 'dark', 'auto'] as const;
export type ThemeMode = (typeof THEME_MODES)[number];
/** data-mode 에 실제 기록되는 resolve 된 모드(auto 제외). */
export type ResolvedMode = 'light' | 'dark';

export interface ThemeMeta {
  key: ThemeKey;
  label: string;
  primaryLight: string;
  primaryDark: string;
}

export const THEMES: Record<ThemeKey, ThemeMeta> = {
  blue: { key: 'blue', label: '블루', primaryLight: '#3b82f6', primaryDark: '#60a5fa' },
  purple: { key: 'purple', label: '퍼플', primaryLight: '#a855f7', primaryDark: '#c084fc' },
  green: { key: 'green', label: '그린', primaryLight: '#22c55e', primaryDark: '#4ade80' },
  orange: { key: 'orange', label: '오렌지', primaryLight: '#f97316', primaryDark: '#fb923c' },
  pink: { key: 'pink', label: '핑크', primaryLight: '#ec4899', primaryDark: '#f472b6' },
};

export function isThemeKey(value: unknown): value is ThemeKey {
  return typeof value === 'string' && (THEME_KEYS as readonly string[]).includes(value);
}

export function isThemeMode(value: unknown): value is ThemeMode {
  return value === 'light' || value === 'dark' || value === 'auto';
}
